import GroupApi from '@api/GroupApi';
import { isArray, uniqWith } from 'lodash';


const uniqueGroups = (groups) => {
  let seen = {};
  let unique = [];
  groups.forEach((g) => {
    if(!seen[g.groupCk]) {
      seen[g.groupCk] = g;
      unique.push(g);
    }
  });
  return unique;
}

export default {
  // reset button
  CLEAR_SELECTION({dispatch, commit, getters, rootGetters}) {
    // console.log(`CLEAR_SELECTION`);
    // why is this an action?  Can't get state in other modules
    //  inside a mutation.
    commit('CLEAR_GROUP');
    commit('CLEAR_SUB_GROUP');
    commit('CLEAR_PARENT_GROUP');
    commit('CLEAR_LOGIN_SUBGROUPS');
    if(rootGetters.isInternalUser) {
      // clear the last search, too
      commit('CLEAR_GROUPS');
      commit('CLEAR_SUB_GROUPS');
      commit('CLEAR_PARENT_GROUPS');
    }
    else {
      dispatch('SET_EXTERNAL_GROUPS');
    }
  },
  // add new member page requires that we be able to JUST unset group/subgroup
  CLEAR_SELECTED({commit, dispatch, getters, rootGetters }, type) {
    // console.log(`CLEAR_SELECTED`, type);
    switch(type) {
      case 'group': {
        let groups = getters['groups'];
        // console.log(`CLEAR_SELECTED group`, groups);
        // if user only has one group, don't clear it.
        // (it would stay auto-selected)
        if(groups.length !== 1) {
          commit('CLEAR_GROUP');
          commit('CLEAR_SUB_GROUPS');
          dispatch('CLEAR_SELECTED', 'subGroup');
        }
        break;
      }
      case 'subGroup': {
        let subGroups = getters['subGroups'];
        // console.log(`CLEAR_SELECTED subGroup`, subGroups);
        // see above
        if(subGroups.length !== 1) {
          commit('CLEAR_SUB_GROUP');
          // this clears it out of billing as well
          commit('CLEAR_SUBGROUP_DETAILS', null, { root: true });
        }
        break;
      }
    }
  },
  // searches groups
  SEARCH_GROUPS({ commit }, opts = {}) {
    commit('SET_SEARCHING');
    commit('CLEAR_SEARCH_RESULTS');
    if(!opts.id) {
      opts.id = '';
    }
    if(!opts.isParentGroupSearch) {
      opts.isParentGroupSearch = false;
    }
    return new GroupApi()
      .search(opts)
      .then(response => {
        if(response.groups && isArray(response.groups)) {
          commit('SET_SEARCH_RESULTS', response.groups);
          commit('SET_PARENT_GROUPS', response.groups);
          commit('SET_GROUPS', response.groups);
        }
      })
      .catch(_ => {
        // todo
      })
      .finally(() => {
        commit('CLEAR_SEARCHING')
      });
  },
  // searches parent groups
  SEARCH_PARENT_GROUPS({ commit, dispatch }, opts) {
    // console.log('SEARCH_PARENT_GROUPS');
    commit('CLEAR_SEARCH_RESULTS');
    opts.isParentGroupSearch = true;
    return new GroupApi()
      .search(opts)
      .then((response) => {
        if(response.groups) {
          // console.log(`response.groups`, response.groups);
          commit('SET_SEARCH_RESULTS', response.groups)
          let parentGroups = [];
          response.groups.forEach((group) => {
            // check for parent
            if(parentGroups.findIndex((pg) => pg.parentGroupCk === group.parentGroupCk) !== -1) {
              // already got it
              return;
            }
            let parentGroup = {
              parentGroupCk: group.parentGroupCk,
              parentGroupId: group.parentGroupId,
              parentGroupName: group.parentGroupName,
              groups: [],
            }
            parentGroups.push(parentGroup)
          });
          commit('SET_PARENT_GROUPS', parentGroups);
          commit('SET_GROUPS', response.groups);
          if(response.groups.length === 1) {
            let opts = response.groups[0];
            opts.type === 'parentGroup';
            dispatch('SET_SELECTED', response.groups[0]);
          }
        }
      })
      .catch((err) => {
        // todo: actually handle an error?
        commit('CLEAR_PARENT_GROUPS');
      })
      .finally(() => {
        commit('CLEAR_SEARCHING');
      });
  },
  SET_SELECTED({commit, getters, rootGetters}, opts) {
    // console.log(`SET_SELECTED`, opts);
    let intExtSelector = rootGetters['isInternalUser'] ? getters['searchResults'] : rootGetters['subGroupAccess'];
    switch (opts.type) {
      case 'parentGroup': {
        let pg = intExtSelector.find((pg) => pg.parentGroupCk === opts.parentGroupCk);
        let rawGroups = intExtSelector.filter((g) => g.parentGroupCk === opts.parentGroupCk);
        // gotta filter out duplicates, as groups are actually stored as the subgroups
        let groups = uniqueGroups(rawGroups);
        // console.log(`groups no dupes`, groups);
        let subGroups = [];
        intExtSelector.forEach((g) => {
          if(g.parentGroupCk === pg.parentGroupCk) {
            if(g.subGroups) {
              g.subGroups.forEach((sg) => {
                // console.log(`sg`, sg);
                subGroups.push(sg);
              })
            }
            else {
              subGroups.push({
                access: g.access,
                subGroupCk: g.subGroupCk,
                subGroupId: g.subGroupId,
                subGroupName: g.subGroupName,
                groupCk: g.groupCk,
                groupId: g.groupId,
                groupName: g.groupName,
                parentGroupCk: g.parentGroupCk,
                parentGroupId: g.parentGroupId,
                parentGroupName: g.parentGroupName,
              })
            }
          }
        });
        // console.log(`parentGroup subs`, subGroups);
        commit('SET_PARENT_GROUP', pg);
        commit('SET_GROUPS', groups);
        commit('SET_SUB_GROUPS', subGroups);
        // only 1 group, so set the group/subgroups too
        if(groups.length === 1) {
          // console.log(`one group`);
          commit('SET_GROUP', groups[0]);
          let groupSubGroups = groups[0].subGroups ? groups[0].subGroups : subGroups.filter((sg) => sg.groupCk === groups[0].groupCk);
          commit('SET_SUB_GROUPS', groupSubGroups);
          // console.log(`groupSubGroups:`, groupSubGroups);
          // if only 1 subGroup, set that too
          if(groupSubGroups.length === 1) {
            commit('SET_SUB_GROUP', groupSubGroups[0]);
          }
          else {
            commit('CLEAR_SUB_GROUP');
          }
        }
        else {
          commit('CLEAR_GROUP');
          commit('CLEAR_SUB_GROUP')
        }
      }
      break;
      case 'group': {
        // console.log(`group`, opts);
        let group = intExtSelector.find((g) => g.groupCk === opts.groupCk);
        let parentGroup = intExtSelector.filter(pg => pg.parentGroupCk === group.parentGroupCk)[0];
        // console.log(`group:`, group);
        let subGroups = [];
        if(group.subGroups && isArray(group.subGroups)) {
          subGroups = [...group.subGroups];
        }
        else {
          intExtSelector.forEach((g) => {
            if(g.groupCk === group.groupCk) {
              if(g.subGroups) {
                g.subGroups.forEach((sg) => subGroups.push(sg));
              }
              else {
                subGroups.push({
                  access: g.access,
                  subGroupCk: g.subGroupCk,
                  subGroupId: g.subGroupId,
                  subGroupName: g.subGroupName,
                  groupCk: g.groupCk,
                  groupId: g.groupId,
                  groupName: g.groupName,
                  parentGroupCk: g.parentGroupCk,
                  parentGroupId: g.parentGroupId,
                  parentGroupName: g.parentGroupName,
                })
              }
            }
          });
        }
        // console.log(`subgroups`, subGroups);
        commit('CLEAR_SUB_GROUP');
        commit('SET_PARENT_GROUP', parentGroup);
        commit('SET_GROUP', group);
        commit('SET_SUB_GROUPS', subGroups);
        if(subGroups.length === 1) {
          // console.log(`subgroups length is `, subGroups.length);
          commit('SET_SUB_GROUP', subGroups[0]);
        }
      }
      break;
      case 'subGroup': {
        // console.log(`subGroup`, opts, intExtSelector);
        let subGroup = null;
        if(rootGetters['isInternalUser'] === true) {
          if(!subGroup) {
            intExtSelector.forEach((g) => {
              if(g.subGroups && isArray(g.subGroups)) {
                let sg = g.subGroups.find((sg) => sg.subGroupCk === opts.subGroupCk);
                if(sg) {
                  sg.groupCk = g.groupCk;
                  sg.parentGroupCk = g.parentGroupCk;
                  subGroup = sg;
                }
              }
            });
          }
        }
        else {
          subGroup = intExtSelector.find((sg) => sg.subGroupCk === opts.subGroupCk);
        }
        // console.log(`found subGroup`, intExtSelector, subGroup);
        if(subGroup) {
          commit('SET_SUB_GROUP', subGroup);
          let parentGroup = intExtSelector.find((pg) => pg.parentGroupCk === subGroup.parentGroupCk);
          let group = intExtSelector.find((g) => g.groupCk === subGroup.groupCk);
          commit('SET_GROUP', group);
          commit('SET_PARENT_GROUP', parentGroup);
        }
        else {
          console.warn(`invalid sg: ${opts.subGroupCk}`);
        }
      }
      break;
    }
  },
  // set external groups
  SET_EXTERNAL_GROUPS({commit, rootGetters}) {
    // console.log(`SET_EXTERNAL_GROUPS`);
    // external user, so grab parentGroups/groups/subGroups from auth
    let userSubGroups = rootGetters['subGroupAccess'];
    // commit('SET_LOGIN_SUBGROUPS', userSubGroups);
    
    // console.log(`set external groups`, userSubGroups);
    // get parent groups
    let parentGroups = [];
    userSubGroups.forEach((subGroup) => {
      // check for parent
      if(parentGroups.findIndex((pg) => pg.parentGroupCk === subGroup.parentGroupCk) !== -1) {
        // already got it
        return;
      }
      let parentGroup = {
        parentGroupCk: subGroup.parentGroupCk,
        parentGroupId: subGroup.parentGroupId,
        parentGroupName: subGroup.parentGroupName,
        groups: [],
      }
      parentGroups.push(parentGroup)
    });
    let allGroups = [];
    parentGroups.forEach((pg) => {
      let subGroupsByParent = userSubGroups.filter((sg) => sg.parentGroupCk === pg.parentGroupCk);
      for(let i = 0; i < subGroupsByParent.length; i++) {
        let sg = subGroupsByParent[i];
        if(!pg.groups.find((g) => g.groupCk === sg.groupCk)) {
          let grp = {
            groupCk: sg.groupCk,
            groupId: sg.groupId,
            groupName: sg.groupName,
            parentGroupCk: pg.parentGroupCk,
            parentGroupId: pg.parentGroupId,
            parentGroupName: pg.parentGroupName,
          };
          grp.subGroups = [...subGroupsByParent.filter((sg) => sg.groupCk === grp.groupCk)];
          // console.log(`subs by parent, group subs`, grp.subGroups);
          pg.groups.push(grp);
          allGroups.push(grp);
        }
      }
    });
    commit('SET_PARENT_GROUPS', parentGroups);
    if(parentGroups.length === 1) {
      commit('SET_PARENT_GROUP', parentGroups[0]);
      let groups = parentGroups[0].groups;
      commit('SET_GROUPS', groups);
      if(groups.length === 1) {
        let group = groups[0];
        commit('SET_GROUP', group);
        let subGroups = group.subGroups;
        commit('SET_SUB_GROUPS', subGroups);
        if(subGroups.length === 1) {
          commit('SET_SUB_GROUP', subGroups[0]);
        }
      }
    }
    else {
      commit('SET_GROUPS', allGroups);
      commit('SET_SUB_GROUPS', userSubGroups);
    }
  }
}
